import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// ── Pages principales ──
import LandingPage            from "./pages/LandingPage";
import Connexion              from "./pages/auth/Connexion";
import Inscription            from "./pages/auth/Inscription";
import Profil                 from "./pages/Profil";
import Contact                from "./pages/Contact";
import Mission                from "./pages/mission";
import ResetPassword from "./pages/auth/ResetPassword";

// ── Hôtels ──
import ListeHotels            from "./pages/ListeHotels";
import DetailHotel            from "./pages/DetailHotel";
import DemandeReservation     from "./pages/DemandeReservation";

// ── Destinations ──
import Destinations           from "./pages/Destinations";
import DetailDestination      from "./pages/DetailDestination";

// ── Services ──
import Loisirs                from "./pages/Loisirs";
import Artisans               from "./pages/Artisans";
import Guides                 from "./pages/Guides";

// ── Restaurants ──
import ListeRestaurants       from "./pages/resto/ListeRestaurants";
import ReservationRestaurant  from "./pages/resto/ReservationRestaurant";
import ReservationGuide       from "./pages/ReservationGuide";

// ── Auth ──
import MdpForgot              from "./pages/auth/MdpForgot";

// ── Transport ──
import Transport              from "./pages/transport/Transport";
import EspaceChauffeur        from "./pages/transport/EspaceChauffeur";

// ── Dashboards ──
import ChauffeurDashboard     from "./pages/dashboards/ChauffeurDashboard";
import BailleurDashboard      from "./pages/dashboards/BailleurDashboard";
import RestauranteurDashboard from "./pages/dashboards/RestauranteurDashboard";
import ArtisanDashboard       from "./pages/dashboards/ArtisanDashboard";
import GuideDashboard         from "./pages/dashboards/GuideDashboard";
import LoueurDashboard        from "./pages/dashboards/LoueurDashboard";
import AdminDashboard         from "./pages/dashboards/AdminDashboard";
import LoisirDashboard        from "./pages/dashboards/LoisirDashboard";

// ── Redirection automatique vers le dashboard si déjà connecté ──
// Corrige le bug : un bailleur/chauffeur/etc. déjà connecté (token en
// localStorage) qui revient sur "/" (nouvel onglet, navigateur rouvert)
// voyait le site public au lieu de son dashboard. Il fallait se
// déconnecter/reconnecter pour le revoir. Cette redirection se fait
// maintenant à chaque chargement de "/", pas seulement au clic sur
// "Se connecter".
const ROLE_DASHBOARDS = {
  admin:        "/admin",
  chauffeur:    "/chauffeur",
  bailleur:     "/bailleur",
  restaurateur: "/restaurateur",
  guide:        "/guide",
  artisan:      "/artisan",
  loueur:       "/loueur",
  loisir:       "/dashboard/loisir",
  // "client" volontairement absent : un client voit bien la landing page
};

function AccueilOuDashboard() {
  const token = localStorage.getItem("token");
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }

  if (token && user.role && ROLE_DASHBOARDS[user.role]) {
    return <Navigate to={ROLE_DASHBOARDS[user.role]} replace />;
  }
  return <LandingPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ── Générales ── */}
        <Route path="/"                         element={<AccueilOuDashboard />} />
        <Route path="/connexion"                element={<Connexion />} />
        <Route path="/inscription"              element={<Inscription />} />
        <Route path="/profil"                   element={<Profil />} />
        <Route path="/contact"                  element={<Contact />} />
        <Route path="/forgot-password"          element={<MdpForgot />} />
        <Route path="/reset-password"           element={<ResetPassword />} />
        <Route path="/mission"                  element={<Mission />} />

        {/* ── Hôtels ── */}
        <Route path="/hotels"                   element={<ListeHotels />} />
        <Route path="/hotels/:id"               element={<DetailHotel />} />
        <Route path="/demande-reservation/:id"  element={<DemandeReservation />} />

        {/* ── Destinations ── */}
        <Route path="/destinations"             element={<Destinations />} />
        <Route path="/destinations/:id"         element={<DetailDestination />} />

        {/* ── Services ── */}
        <Route path="/loisirs"                  element={<Loisirs />} />
        <Route path="/artisans"                 element={<Artisans />} />
        <Route path="/guides"                   element={<Guides />} />

        {/* ── Restaurants ── */}
        <Route path="/restaurants"              element={<ListeRestaurants />} />
        <Route path="/reservation-restaurant"   element={<ReservationRestaurant />} />
        <Route path="/reservation-guide"        element={<ReservationGuide />} />

        {/* ── Transport ── */}
        <Route path="/transport"                element={<Transport />} />
        <Route path="/espace-chauffeur"         element={<EspaceChauffeur />} />

        {/* ── Dashboards ── */}
        <Route path="/chauffeur"                element={<ChauffeurDashboard />} />
        <Route path="/bailleur"                 element={<BailleurDashboard />} />
        <Route path="/restaurateur"             element={<RestauranteurDashboard />} />
        <Route path="/artisan"                  element={<ArtisanDashboard />} />
        <Route path="/guide"                    element={<GuideDashboard />} />
        <Route path="/loueur"                   element={<LoueurDashboard />} />
        <Route path="/admin"                    element={<AdminDashboard />} />
        <Route path="/dashboard/loisir" element={<LoisirDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}